import { render, staticRenderFns } from "./BindsTabs.vue?vue&type=template&id=ef26b150&"
import script from "./BindsTabs.vue?vue&type=script&lang=js&"
export * from "./BindsTabs.vue?vue&type=script&lang=js&"
import style0 from "./BindsTabs.vue?vue&type=style&index=0&id=ef26b150&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports